import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { TimelineEntry } from '../../reducers/transport';

const fmtDt = (dateStr: string | null): string => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${day}/${month} ${hours}:${minutes}`;
};

const ch: React.CSSProperties = {
    background: 'linear-gradient(135deg, #1e3a5f 0%, #2a5a8a 100%)',
    padding: '10px 16px', borderRadius: '8px 8px 0 0',
    fontSize: 12, fontWeight: 600, color: '#fff', textTransform: 'uppercase',
    letterSpacing: '0.5px', display: 'flex', alignItems: 'center', gap: 8,
};
const cb: React.CSSProperties = {
    background: '#fff', border: '1px solid #d0dbe8', borderTop: 'none',
    borderRadius: '0 0 8px 8px', padding: 14,
};

const eventColors: Record<string, string> = {
    created: '#3b82f6', status_changed: '#f59e0b', departed: '#2a5a8a',
    arrived: '#22c55e', item_added: '#0891b2', item_removed: '#ef4444',
    item_delivered: '#22c55e', checklist_checked: '#059669', checklist_unchecked: '#94a3b8',
    driver_assigned: '#7c3aed', edited: '#64748b', note_added: '#64748b',
};

interface Props {
    entries: TimelineEntry[];
}

const TransportTimeline: React.FC<Props> = ({ entries }) => {
    const intl = useIntl();
    const fm = (id: string, defaultMessage: string) => intl.formatMessage({ id, defaultMessage });

    return (
        <div>
            <div style={ch}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                </svg>
                <FormattedMessage id="transport.timeline.header" defaultMessage="Aktiviteti" />
                {entries.length > 0 && <span style={{ opacity: 0.7, fontWeight: 400 }}>({entries.length})</span>}
            </div>
            <div style={{ ...cb, maxHeight: 260, overflow: 'auto' }}>
                {(!entries || entries.length === 0) && (
                    <div style={{ textAlign: 'center', padding: '10px 0', color: '#94a3b8', fontSize: 11 }}><FormattedMessage id="transport.timeline.empty" defaultMessage="Nuk ka aktivitet" /></div>
                )}
                {entries.map((entry, idx) => {
                    const color = eventColors[entry.eventType] || '#94a3b8';
                    return (
                        <div key={entry.id} style={{ display: 'flex', gap: 10, paddingBottom: idx < entries.length - 1 ? 10 : 0, position: 'relative' }}>
                            {idx < entries.length - 1 && (
                                <div style={{ position: 'absolute', left: 5, top: 14, bottom: 0, width: 1, background: '#e2e8f0' }} />
                            )}
                            <div style={{ width: 10, height: 10, borderRadius: '50%', flexShrink: 0, background: color, marginTop: 3, position: 'relative', zIndex: 1 }} />
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontSize: 12, color: '#0f172a' }}>{entry.description}</div>
                                <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 1 }}>
                                    {entry.user?.name || fm('transport.timeline.system', 'Sistemi')}
                                    {entry.createdAt && <span style={{ marginLeft: 6 }}>{fmtDt(entry.createdAt)}</span>}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default TransportTimeline;
